import {
  FETCH_OFFERS_REQUEST,
  FETCH_RECURRING_OFFERS_REQUEST,
} from 'constants/offers';
import type { RootState } from 'reducers/types';
import {
  financialInstitutionIndia,
  sourceOfFundsIndia,
} from 'selectors/ui/india/ui';
import type { PayexThunkAction } from 'store/configureStore';
import {
  getFetchOffersParams,
  onFetchOffersError,
  onFetchOffersSuccess,
  onFetchRecurringOffersError,
  onFetchRecurringOffersSuccess,
  shouldFetchOffers,
} from '../fetchOffers';

export const fetchOffersFromOrderIfNeededForIndia =
  (): PayexThunkAction<Promise<void>> =>
  (dispatch, getState, { payex }) => {
    if (shouldFetchOffers(getState())) {
      const state = getState();

      const { isFetchingOffers, ...params } = getFetchOffersParams(state);

      if (isFetchingOffers) {
        return Promise.resolve();
      }

      const indianParams = getIndiaFilterParams(state);

      dispatch({
        type: FETCH_OFFERS_REQUEST,
      });

      return payex.offers
        .getAll({ ...params, ...indianParams })
        .then(response => dispatch(onFetchOffersSuccess(response)))
        .catch(error => dispatch(onFetchOffersError(error)));
    }

    return Promise.resolve();
  };

export const fetchRecurringOffersFromOrderForIndia =
  ({
    installments,
  }: { installments: number }): PayexThunkAction<Promise<void>> =>
  (dispatch, getState, { payex }) => {
    const state = getState();

    const { isFetchingOffers, ...params } = getFetchOffersParams(state, true);

    if (isFetchingOffers) {
      return Promise.resolve();
    }

    const indiaParams = getIndiaFilterParams(state);

    dispatch({
      type: FETCH_RECURRING_OFFERS_REQUEST,
    });

    return payex.offers
      .getRecurringOffers({ ...params, ...indiaParams, installments })
      .then(response => {
        dispatch(onFetchRecurringOffersSuccess(response));
      })
      .catch(error => {
        dispatch(onFetchRecurringOffersError(error));
      });
  };

const getIndiaFilterParams = (state: RootState) => {
  const sourceOfFunds = sourceOfFundsIndia(state);
  const financialInstitution = financialInstitutionIndia(state);

  return {
    sourceOfFunds: sourceOfFunds as string,
    financialInstitution: financialInstitution as string,
  };
};
